import { useRef } from 'react';

/**
 * Radix springt beim Schließen nur zu einem `Dialog.Trigger` zurück; die meisten Dialoge öffnen
 * ohne (aus Menüs, Blättern, Listen). Gemerkt wird deshalb, was beim Öffnen den Fokus hatte, und
 * dorthin geht er zurück – solange es das Element noch gibt und der Aufrufer nichts anderes will.
 */
export function useReturnFocus(
  onOpenAutoFocus?: (event: Event) => void,
  onCloseAutoFocus?: (event: Event) => void,
) {
  const opener = useRef<HTMLElement | null>(null);
  return {
    onOpenAutoFocus: (event: Event) => {
      const active = document.activeElement;
      opener.current = active instanceof HTMLElement && active !== document.body ? active : null;
      onOpenAutoFocus?.(event);
    },
    onCloseAutoFocus: (event: Event) => {
      onCloseAutoFocus?.(event);
      const target = opener.current;
      if (event.defaultPrevented || !target?.isConnected) return;
      event.preventDefault();
      target.focus();
    },
  };
}
